import { Component,EventEmitter,OnInit,Output} from '@angular/core';
import { Project } from '../../models/project';
import { DropdownChangeEvent } from 'primeng/dropdown';
import { DataSet } from '../../models/echo/data-set';
import { Molecule } from '../../models/echo/molecule';
import { Chemical } from '../../models/trex/trex-inputs';
import { UseEndpointDatasetLogicService } from './use-endpoint-dataset-logic-service';
import { EndpointDatasetComponent } from '../endpoint-dataset/endpoint-dataset.component';
import { CompoundPkAndName } from '../../models/compound';
import { Constants } from '../../utils/constants';

@Component({
  selector: 'app-use-endpoint-dataset',
  templateUrl: './use-endpoint-dataset.component.html',
  styleUrls: ['./use-endpoint-dataset.component.css'],
})
export class UseEndpointDatasetComponent implements OnInit {

  @Output() onClickSaveButton = new EventEmitter<any>();

  columnDefs: any = [];
  rowData: any[] = [];
  visible: boolean = false;
  projectPk?: number;
  selectedProject?: Project;
  isLoading: boolean = false;
  filteredDatasets: DataSet[] = [];
  selectedMolecule?: Molecule;
  selectedCompound?: CompoundPkAndName;
  activeIngredients: Chemical[] = [];
  selectedDataSet?: DataSet[];
  dataSetListAdded: DataSet[] = [];
  selectedDataSetAdded?: DataSet[];
  removedDataSet: DataSet[] = [];
  source: string = '';
  parentDropDownOptions: CompoundPkAndName[] = [];

    constructor(
    private useDataSetLogic: UseEndpointDatasetLogicService,
    private datasetModule: EndpointDatasetComponent
  ) { }

  ngOnInit(): void {
    this.filteredDatasets = [];
  }

  onSelectionChanged({ originalEvent, value }: DropdownChangeEvent) {
    if (originalEvent && value) {
      this.selectedProject = value;
      return;
    }
    this.selectedProject = undefined;
  }

  showDialog(visiblePopUp: boolean, project?: Project, source?: string) {
    this.parentDropDownOptions = this.getDropDownOptions(source);
    this.selectedProject = project;
    this.visible = visiblePopUp;
    this.projectPk = project?.projectPk;
    this.source = source!;
  }

  getDropDownOptions(source?: string): CompoundPkAndName[] {
    return source === Constants.FEATURE_ACRONYM.ENVIRONMENTAL_EXPOSURE_ASSESSMENT && this.datasetModule.logicService.isInverseModeling == false ? 
    this.datasetModule.logicService.parentDropDownOptions :
    this.datasetModule.logicService.parentDropDownOptions.filter((compound: CompoundPkAndName) => compound.compoundType === Constants.SUBSTANCE_TYPES.ACTIVE);
  }

  close() {
    this.visible = false;
    this.selectedMolecule = undefined;
    this.selectedCompound = undefined;
    this.dataSetListAdded = [];
    this.filteredDatasets = [];
  }
  closeDialog() {
    this.visible = false;
    this.selectedMolecule = undefined;
    this.selectedCompound = undefined;
  }

  async selectionChange({ originalEvent, value }: DropdownChangeEvent) {
    this.selectedCompound = value;
    if (value) {
      let moleculePk = this.getMoleculePk(value);
      await this.getDataSetByMoleculeExcludeDSProject(moleculePk).then();
    }
  }

  getMoleculePk(compound: CompoundPkAndName): number {
    return compound.compoundType === Constants.SUBSTANCE_TYPES.ACTIVE? compound.compoundPk! :
    this.selectedProject?.projectXCompoundXModel?.find((x) => x.MetabolitePk === compound.compoundPk)?.MoleculePk!;
  }

  getPk(dataset: any) {
    const dataSetsSelected: DataSet[] = dataset.value;
    if (dataSetsSelected.length > 0) {
      {
        this.selectedDataSetAdded = dataSetsSelected;
      }
    } else {
      this.dataSetListAdded = [];
    }
  }

  async setDataSetToProject() {
    try {
      if (this.dataSetListAdded.length > 0) {
        this.dataSetListAdded = this.useDataSetLogic.distinctByDescription(
          this.dataSetListAdded as { description: string | undefined }[]
        );
        this.dataSetListAdded.forEach((dataset: DataSet) => {
          dataset.projectPk = this.projectPk!;
        });
        await this.useDataSetLogic.save(this.dataSetListAdded);
      }
      this.refresh();
    } catch (error) {
      console.error(error);
    }
  }

  refresh() {
    this.datasetModule.setRowData();
    this.visible = false;
  }

  async getDataSetByMoleculeExcludeDSProject(
    moleculePk: number
  ): Promise<void> {
    this.isLoading = true;
    try {
      const [dataset$, dataSetToAssign, projectDS] = await Promise.all([
        this.useDataSetLogic.getDataSetByMoleculesPks(
          [moleculePk],
          this.source
        ),
        this.useDataSetLogic.getDatasets(
          this.projectPk!,
          this.source,
          moleculePk
        ),
        this.useDataSetLogic.getDataSetByProject(this.projectPk!, this.source),
      ]);

      const distinctDatasets = this.useDataSetLogic
        .distinctByDescription(
          dataset$ as {
            originalProject: number | undefined;
            dataSetPk: number | undefined;
            description: string | undefined;
          }[]
        )
        .sort((a, b) =>
          String(a.description).localeCompare(String(b.description))
        );

      let tempData = distinctDatasets
        .filter(
          (dataset) =>
            !projectDS.some((item) => item.dataSetPk === dataset.dataSetPk)
        )
        .filter((x) => x.originalProject !== this.projectPk);
      this.filteredDatasets = this.loadFilteredDatasets(tempData);

    } catch (error) {
      console.error(error);
    } finally {
      this.isLoading = false;
    }
  }

  loadFilteredDatasets(dataSets: DataSet[]): DataSet[] {
   return this.selectedCompound?.compoundType === Constants.SUBSTANCE_TYPES.ACTIVE ?
   dataSets.filter((dataSet: DataSet) => dataSet.substanceType === Constants.SUBSTANCE_TYPES.ACTIVE) :
   dataSets.filter((dataset) => dataset.metabolitePk === this.selectedCompound?.compoundPk);
  }

  async removeDataSetByProjectAndPk(event: any) {
    var dataSetDeleted: DataSet = event.option;
    if (dataSetDeleted) {
      try {
        this.dataSetListAdded.splice(
          this.dataSetListAdded.indexOf(dataSetDeleted),
          1
        );
        this.filteredDatasets.push(dataSetDeleted);
        this.filteredDatasets = this.filteredDatasets.sort((a, b) =>
          String(a.description).localeCompare(String(b.description))
        );
      } catch (error) {
        console.error(error);
      }
    }
  }

  addDataSetToList(event: any) {
    const dataSetAdded: DataSet[] = event.option;
    if (dataSetAdded) {
      const uniqueDataSets = new Set(
        this.dataSetListAdded.concat(dataSetAdded)
      );
      this.dataSetListAdded = Array.from(uniqueDataSets);
      this.selectedDataSetAdded = this.dataSetListAdded;
      this.filteredDatasets = this.filteredDatasets.filter(
        (dataset) => !uniqueDataSets.has(dataset)
      );
      this.filteredDatasets = this.filteredDatasets.sort((a, b) =>
        String(a.description).localeCompare(String(b.description))
      );
    }
  }
}
